import { render, staticRenderFns } from "./clist.vue?vue&type=template&id=2ad05ca5&scoped=true&"
import script from "./clist.vue?vue&type=script&lang=js&"
export * from "./clist.vue?vue&type=script&lang=js&"
import style0 from "./clist.vue?vue&type=style&index=0&id=2ad05ca5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad05ca5",
  null
  
)

export default component.exports